import api from '../../../utils/api';

export function unwrapInviteList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
}

export function memberInviteErrorMessage(err, fallback = 'Could not send that invite.') {
  const data = err?.response?.data;
  const apiError = data?.error;
  if (typeof apiError === 'string' && apiError.trim()) return apiError;
  const detail = data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (!err?.response && typeof err?.message === 'string' && err.message.trim()) return err.message;
  return fallback;
}

export function inviteSentToast(status) {
  if (status === 'pending') {
    return {
      title: 'Invite already pending',
      body: 'They still need to accept from their inbox.',
      variant: 'info',
    };
  }
  return {
    title: 'Invite sent',
    body: 'They will appear on the roster after they accept.',
    variant: 'success',
  };
}

export async function searchAvailableClubUsers(clubId, q, { limit = 10 } = {}) {
  const res = await api.get(`/clubs/${clubId}/available_users/`, {
    params: { q, limit },
  });
  return Array.isArray(res?.data) ? res.data : [];
}

export async function fetchClubMemberInvites(clubId, { status = 'pending' } = {}) {
  const params = {};
  if (status) params.status = status;
  const res = await api.get(`/clubs/${clubId}/member-invites/`, { params });
  return unwrapInviteList(res?.data);
}

export async function createClubMemberInvite(clubId, userId) {
  const res = await api.post(`/clubs/${clubId}/member-invites/`, { user_id: userId });
  return res?.data;
}

export async function fetchMyMemberInvites({ status = 'pending' } = {}) {
  const params = {};
  if (status) params.status = status;
  const res = await api.get('/clubs/member-invites/', { params });
  return unwrapInviteList(res?.data);
}

export async function acceptClubMemberInvite(inviteId) {
  const res = await api.post(`/clubs/member-invites/${inviteId}/accept/`);
  return res?.data;
}

export async function declineClubMemberInvite(inviteId) {
  const res = await api.post(`/clubs/member-invites/${inviteId}/decline/`);
  return res?.data;
}

export function clubIdFromInvite(invite) {
  const raw = invite?.club_id ?? invite?.club?.id;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function acceptedInvitePath(invite) {
  const clubId = clubIdFromInvite(invite);
  return clubId ? `/clubs/${clubId}/rules?join=1` : '/clubs';
}
